import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dropdown-trigger" }
const _hoisted_2 = ["aria-controls", "disabled"]
const _hoisted_3 = { class: "icon is-small" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "dropdown-content" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass([{'is-active': _ctx.active}, "dropdown is-up"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "button",
          "aria-haspopup": "true",
          "aria-controls": _ctx.dropdown_menu_id,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.active = !_ctx.active)),
          disabled: _ctx.disabled
        }, [
          _renderSlot(_ctx.$slots, "selected", {}, undefined, true),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_ion_icon, { name: "chevron-down-outline" })
          ])
        ], 8, _hoisted_2)
      ]),
      _createElementVNode("div", {
        class: "dropdown-menu",
        id: _ctx.dropdown_menu_id,
        role: "menu"
      }, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("a", {
              href: "#",
              key: option,
              onClick: _withModifiers(($event: any) => {_ctx.$emit('clicked', option); _ctx.active = false}, ["prevent"]),
              class: "dropdown-item"
            }, [
              _renderSlot(_ctx.$slots, "option", { option: option }, undefined, true)
            ], 8, _hoisted_6))
          }), 128))
        ])
      ], 8, _hoisted_4)
    ], 2)
  ]))
}